export var WebSocketRequest = 'WebSocketRequest';
export var DefaultSearchContext = '@@root';
//# sourceMappingURL=constants.js.map